<template>
    <v-row no-gutters class="pr-8 pl-9 pt-8">
        <v-col cols="12">
            <LoginOptions
                :settings="settings"
                :can-edit-owner-locked-settings="canEditOwnerLockedSettings"
                @set-settings="setSettingsValue"
            />
        </v-col>
    </v-row>
</template>

<script>
import {computed, reactive, ref, watch} from "@vue/composition-api";
import AppStoreDialog from "@/store/modules/AppStoreDialog/appStoreDialog";
import LoginOptions from "@/views/AppStore/Company/Security/LoginOptions";
import { $t } from "@/i18n";
import Loader from "@/utility/loader";
import ApiCompanySecuritySettings from "@/api/company/companySecuritySettings";
import errorDialog from "@/views/ErrorDialog/errorDialog";
import AccountModule from "@/store/modules/account";
import { deepClone } from "@/helpers/helpers";
import {startLoginProcess} from "@/modules/auth/microsoftAuth";
import AppModule from "@/store/modules/app";
import FeedbackNotificationModule from "@/store/modules/feedback_notification";
import RightsModule from "@/composables/use-rights";
import router from '@/router'

export default {
    name: "CompanyDialogSecurityTab",
    components: {
        LoginOptions
    },
    props: {
        isSelected: {
            type: Boolean,
            default: false
        }
    },
    setup(props) {
        const { can_edit_owner_locked_settings } = RightsModule();
        const { appStoreDialogGetters, appStoreDialogActions } = AppStoreDialog()
        const accountModule = AccountModule();
        const loader = reactive(new Loader());
        const appModule = AppModule();
        const { current_account } = AccountModule();
        const { showFeedbackNotification } = FeedbackNotificationModule();

        const selectedAccount = computed(() => {
            return appStoreDialogGetters.getSelectedCompany()
        });

        const getInitialSettingsData = () => {
            return deepClone(selectedAccount.value.data.login_data)
        }

        const settings = ref(getInitialSettingsData());

        const canEditOwnerLockedSettings = computed(() => can_edit_owner_locked_settings(selectedAccount.value))

        const openAppRun = router.currentRoute.query.open_app_run
        if(openAppRun === 'enablexero' && canEditOwnerLockedSettings.value) {
            settings.value.xero_enabled = true
        }

        const getMicrosoftToken = async () => {
            const loginResponse = await startLoginProcess(appModule.azure_ad_app_id.value, current_account.value.email)
            if (loginResponse) {
                return loginResponse['idToken']
            }
        }

        const onSave = () => {
            loader.withLoader(async () => {
                try {
                    let payload = { ...settings.value }

                    if (settings.value.microsoft_enabled && settings.value.microsoft_tenant_id && settings.value.microsoft_tenant_id !== '' && current_account.value.microsoft_id) {
                        payload.microsoft_token = await getMicrosoftToken();
                        if (!payload.microsoft_token) {
                            return
                        }
                    }

                    const resp = await ApiCompanySecuritySettings.saveCompanySecuritySettings(selectedAccount.value.id, payload)
                    accountModule.updateAccountSettings(resp)

                    showFeedbackNotification($t('Settings saved'))
                } catch (e) {
                    errorDialog.showError(e)
                }
            })
        };

        const setSettingsValue = (settingsValue) => {
            settings.value = settingsValue
        }

        const isLoading = computed(() => loader.isLoading)

        watch (() => props.isSelected, () => {
            if (props.isSelected && canEditOwnerLockedSettings.value) {
                appStoreDialogActions.setFooterActions([
                    {
                        text: $t("Save"),
                        class: "primary",
                        loading: isLoading,
                        click: onSave
                    }
                ]);
            }
        }, { immediate: true })

        return {
            selectedAccount,
            setSettingsValue,
            settings,
            canEditOwnerLockedSettings
        };
    }
};
</script>
